import React, { useRef } from 'react'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

import useOnClickOutside from 'use-onclickoutside'


const Wrapper = styled.div`
  /* position: relative; */
  position: absolute;
  top: ${p => p.position.top + 25}px;
  left: ${p => p.position.left - 164}px;
  z-index:999;
`


const DropDown = styled.ul`
  @media ${p => p.theme.sm} {
    top: 19px;
    /* right: -2px; */
    left: -23px;
  }

  z-index: 5;
  position: absolute;
  top: 7px;
  left: 6px;
  width: 400px;
  padding: 8px 8px;
  background-color: white;
  border: 2px solid #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);

  &::before {
    @media ${p => p.theme.sm} {
      right: 17px;
    }

    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -12px;
    left: 185px;
    /* left: 22px; */
    border-bottom: 12px solid #fff;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    z-index: 1;
  }

  &::after {
    @media ${p => p.theme.sm} {
      right: 15px;
    }

    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -15px;
    left: 183px;
    /* left: 20px; */
    border-bottom: 14px solid #f1f1f1;
    border-left: 14px solid transparent;
    border-right: 14px solid transparent;
  }
`

//
// This controls the columns available in the sidebar. Note tat extraConfig and stringConfig should be the same. StringConfig is just for optimizing search
//
// extraConfig: contains array of column configuration in 12-based numbers
// stringConfig: same as extraConfig but in string format *NOTE* used for optimize search
// cssConfig: contains the css class to use for this column config.
//
const colConfigs = [
    { extraConfig: [12], stringConfig: "12", cssConfig: [100] },
    { extraConfig: [6, 6], stringConfig: "6,6", cssConfig: [50, 50] },
    {
        extraConfig: [4, 4, 4],
        stringConfig: "4,4,4",
        cssConfig: [33, 33, 33]
    },
    {
        extraConfig: [3, 6, 3],
        stringConfig: "3,4,3",
        cssConfig: [30,40,30]
    },
    {
        extraConfig: [2, 8, 2],
        stringConfig: "2,8,2",
        cssConfig: [20,60,20]
    },
    {
        extraConfig: [3, 3, 3, 3],
        stringConfig: "3,3,3,3",
        cssConfig: [25, 25, 25, 25]
    },
    { extraConfig: [5, 7], stringConfig: "5,7", cssConfig: [40, 60] },
    { extraConfig: [7, 5], stringConfig: "7,5", cssConfig: [60, 40] },
    { extraConfig: [4, 8], stringConfig: "4,8", cssConfig: [33, 66] },
    { extraConfig: [8, 4], stringConfig: "8,4", cssConfig: [66, 33] },
    { extraConfig: [3, 9], stringConfig: "3,9", cssConfig: [25, 75] },
    { extraConfig: [9, 3], stringConfig: "9,3", cssConfig: [75, 25] },
    {
        extraConfig: [2, 10],
        stringConfig: "2,10",
        cssConfig: [20, 80]
    },
    {
        extraConfig: [10, 2],
        stringConfig: "10,2",
        cssConfig: [80, 20]
    },
    {
        extraConfig: [1, 11],
        stringConfig: "1,11",
        cssConfig: [10, 90]
    },
    { extraConfig: [11, 1], stringConfig: "11,1", cssConfig: [90, 10] }
];

const Column = styled.div`
    width: ${props => +props.width}%;
    height: 20px;
    background-color: ${p=>p.disabled ? p.theme.backgrounds.danger : '#ddd'};
    /* background-color: ${p => p.theme.colors.primary}; */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 4px;
`

const Button = styled.button`
  width: 100%;
  background-color: white;
  border-style: none;
  border-width: 1px;
  border-color: #dde6e9;
  padding: 8px;
  font-size: 10px;
  /* margin-bottom: 12px; */
  /* height: 40px; */

  &:hover ${Column} {
    background-color: ${p => p.disabled ? p.theme.backgrounds.danger : p.theme.colors.secondary};
  }

`;

const ColIcon = styled.div`
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

const ColumnConfig = (props) => {

    const { colConfig = {}, setRowColumnConfig } = props;
    const { extraConfig = [], cssConfig = [], stringConfig = '' } = colConfig;

    const disabled = extraConfig.length < props.maxCols

    return (
        <Button
            disabled={disabled}
            onClick={disabled ? () => {} : (e) => { e.stopPropagation(); setRowColumnConfig({ colConfig: extraConfig }) }}
            aria-label={`Column config - ${stringConfig}`}
        >
            <ColIcon>
                {extraConfig.map((fill, i) => {
                    return <Column disabled={disabled} key={i} width={cssConfig[i]} />;
                })}
            </ColIcon>
        </Button>
    );
}

export default (props) => {

    const { maxCols } = props;

    const ref = useRef()

    const close = () => props.setOpen(false)

    useOnClickOutside(ref, close)

    const modalRoot = document.getElementById( 'modal' )

    return createPortal(

        <Wrapper ref={ref} position={props.position}>
            <DropDown>
                {colConfigs.map((colConfig, i) => {

                    return (
                        <ColumnConfig
                            key={i}
                            colConfig={colConfig}
                            setRowColumnConfig={props.setRowColumnConfig}
                            id={props.id}
                            maxCols={maxCols}
                        />
                    );

                })}
            </DropDown>
        </Wrapper>

    , modalRoot)
}

